function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1181 7.98484C15.1181 11.7454 12.0696 14.7939 8.30906 14.7939C4.54852 14.7939 1.5 11.7454 1.5 7.98484C1.5 4.2243 4.54852 1.17578 8.30906 1.17578C12.0696 1.17578 15.1181 4.2243 15.1181 7.98484Z",
  fill: "#4290F3",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7018 8.23688C15.1691 8.23688 15.5529 7.85681 15.5004 7.39241C15.3382 5.95744 14.7651 4.59295 13.8414 3.46743C12.738 2.12289 11.2025 1.20254 9.49656 0.863209C7.79062 0.523877 6.0198 0.786553 4.48583 1.60648C2.95185 2.42641 1.74963 3.75286 1.084 5.35981C0.418379 6.96677 0.330538 8.75481 0.835447 10.4193C1.34036 12.0837 2.40677 13.5216 3.853 14.488C5.29922 15.4543 7.03577 15.8893 8.76675 15.7188C10.2158 15.5761 11.5858 15.0165 12.7152 14.1165C13.0807 13.8252 13.0781 13.2851 12.7476 12.9546C12.4171 12.6242 11.8844 12.63 11.5096 12.9092C10.6645 13.5385 9.65991 13.9302 8.60086 14.0345C7.25955 14.1666 5.91392 13.8296 4.79326 13.0808C3.67261 12.332 2.84625 11.2178 2.45501 9.92798C2.06376 8.63822 2.13183 7.25269 2.64761 6.00748C3.16339 4.76227 4.09498 3.73443 5.28363 3.09907C6.47229 2.46372 7.84447 2.26018 9.16638 2.52312C10.4883 2.78607 11.6781 3.49923 12.5332 4.5411C13.2083 5.36371 13.6417 6.35106 13.7942 7.3936C13.8618 7.85603 14.2344 8.23688 14.7018 8.23688Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7285 7.29688L14.608 9.17641L16.4876 7.29688",
  stroke: "#4290F3",
  strokeWidth: 1.78011,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.a335108d.svg";
export { ForwardRef as ReactComponent };